import {Environment, getEnvironment, isLocal} from '@/services/infrastructure/envhelper.service'
import {TogglableFeature} from '@/feature-toggles/feature-toggler.service'

export const InvoiceDraftList: TogglableFeature = {
    isEnabled: () => {
        return getEnvironment() !== Environment.Production && getEnvironment() !== Environment.PreProduction && false
    }
}

export const ManualInvoiceDebtCollectionSync: TogglableFeature = {
    isEnabled: () => {
        return isLocal()
    }
}